'use client';
import { useEffect, useRef, useState } from 'react';
import { useFocus } from './useFocus';
export const useIsFocused = (ref) => {
    const [isFocused, setIsFocused] = useState(undefined);
    const isFocusedRef = useRef(isFocused);
    isFocusedRef.current = isFocused;
    useFocus(ref, (props) => setIsFocused(props.isFocused));
    useEffect(() => {
        const refElement = ref.current;
        if (isFocusedRef.current === undefined) {
            setIsFocused(document.activeElement === refElement);
        }
    }, [ref]);
    return isFocused;
};
